import React from 'react'
import { Typography, Grid } from '@material-ui/core'
import PropTypes from 'prop-types'

function EmptyLayout({ link, description, ...rest }) {
  return (
    <Grid
      container
      spacing={1}
      justify="center"
      alignItems="center"
      direction="column"
      {...rest}
    >
      <Grid item>{description}</Grid>
      <Grid item>{link}</Grid>
    </Grid>
  )
}
export const EmptyText = ({ descriptionLabel, variant = 'subtitle1' }) => {
  return (
    <Typography variant={variant} color="textSecondary">
      {descriptionLabel}
    </Typography>
  )
}

export default function EmptyContent({
  linkLabel,
  linkProp,
  descriptionLabel,
  ...rest
}) {
  return (
    <EmptyLayout
      {...rest}
      className="pt-36 pb-36 px-4"
      description={<EmptyText descriptionLabel={descriptionLabel} />}
    />
  )
}

EmptyContent.propTypes = {
  linkLabel: PropTypes.element,
  linkProp: PropTypes.object,
  descriptionLabel: PropTypes.element,
}
